// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2K8DQ","cardHeader":"styles_cardHeader__2rCRO","buttons":"styles_buttons__sRw9V"};